import { z } from "zod";

/**
 * AlterarInativoAtivoSchema
 */

export const AlterarInativoAtivoSchema = z.object({
  Ativo: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
  DataTermino: z.coerce.date().nullable().optional(),
});

/**
 * AlterarInativoAtivoForm
 */

export type AlterarInativoAtivoForm = z.infer<typeof AlterarInativoAtivoSchema>;